export const adultosPromoData = {
  tempra: {
    slides: [
      {
        desktopImage: {
          src: '/images/tempra-adultos-banner-crossbrand-desktop.png',
          altText: 'Tempra Forte y Lysol',
        },
        mobileImage: {
          src: '/images/tempra-adultos-banner-crossbrand-mobile.png',
          altText: 'Tempra Forte y Lysol',
        },
        headline: '¿ÉPOCA DE CONTAGIOS?',
        subHeading: 'CONFÍA EN TUS ALIADOS',
        cta: {
          label: 'COMPRAR AHORA',
          ariaLabel: 'Comprar ahora',
          link: '/where-to-buy/',
        },
        legal:
          'Lea la etiqueta de cada producto antes de su uso. SI PERSISTEN LAS MOLESTIAS, CONSULTA A TU MÉDICO. CUIDA EL AGUA. Reg. San. 128M99 SSA VI. PERMISO DE PUBLICIDAD NO. 203300201B1062. *Eliminando el 99.9% de gérmenes en más de 100 objetos. Consulta más de 100 objetos en: https://www.lysol.com.mx/100-objetos/ Consulta más de 100 gérmenes en: https://www.lysol.com.mx/100-germenes/',
      },
    ],
  },
};
